<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Holidays</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input class="form-control radius-0 font-13" [(ngModel)]="desc" placeholder="Description">
    </div>
    <div class="form-group">

      <!--<app-ngb-multi-date-picker [datesSelected]="datesSelected"-->
      <!--(datesSelectedChange)="change($event)"></app-ngb-multi-date-picker>-->
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5"
             placeholder="Holiday" [(ngModel)]="holidays" readonly>
      <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>

    </div>
    <div class="form-group font-13">
      <mat-radio-group (change)="onButtonChange($event)">
        <mat-radio-button value="F" [checked]="true">Full Day</mat-radio-button>
        <mat-radio-button value="H">Partial Day</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-group" [hidden]="isHidden">
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt13" [owlDateTime]="dt13"
             placeholder="Holiday Start" [(ngModel)]="hourStart" readonly>
      <owl-date-time [pickerType]="'timer'" #dt13></owl-date-time>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
